exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideshow .slide[data-v-758b6b83]{align-items:center;justify-content:center}.slideshow .slide img[data-v-758b6b83]{width:100%;-o-object-fit:cover;object-fit:cover;margin:0 auto;display:block}", ""]);

// exports
